import { ConstantRoutes } from "../../../core/constantRoutes";
import { ConstantInfo } from "../../../core/constantInfo";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col bg-[#10121B] border-b border-b-[#1A1C29]">
        <div
          className="max-w-screen-2xl w-full place-self-center text-center pt-10
         flex md:flex-row max-md:flex-col justify-around"
        >
          <div className="flex flex-col text-left space-y-2">
            <p className="text-textsecondary pb-2 text-lg">Important links</p>

            <ul className="list-inside list-[square] pl-0 space-y-2 marker:text-content2">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <a
                  href={`${ConstantRoutes.about}`}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {t("About")}
                </a>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <a
                  href={`${ConstantRoutes.privacyPolicy}`}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {t("Privacy policy")}
                </a>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <a
                  href={`${ConstantRoutes.termsAndConditions}`}
                  className="hover:text-primary transition-colors duration-200"
                >
                  {t("Terms and Conditions")}
                </a>
              </li>
            </ul>
          </div>

          <a
            href="https://www.evc.de/en/check_evc_license.asp?k=VHR%2fTUSdhTiijbBYVOb0Ww%3d%3d"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://www.evc.de/common/check_evc_license_image.asp?k=VHR%2fTUSdhTiijbBYVOb0Ww%3d%3d"
              alt="Licensedd WinOLS5 user"
            />
          </a>

          <div className="flex flex-col text-left max-md:p-4">
            <p className="text-textsecondary text-lg">Contact:</p>

            <p className="text-textsecondary pt-2">
              WhatsApp:
              <a
                className="hover:text-primary text-white pl-2"
                href={ConstantInfo.phone}
              >
                {ConstantInfo.phoneView}
              </a>
            </p>

            <p className="text-textsecondary pt-2">
              Support:
              <a
                className="hover:text-primary text-white pl-2"
                href={ConstantInfo.email + "Another question"}
              >
                {ConstantInfo.emailView}
              </a>
            </p>

            <p className="text-textsecondary text-lg pt-4">Address:</p>

            <p className="pt-2">DME-Tech LLC</p>
            <p className=" pt-2">1007 N Orange St, Wilmington, DE 19801, USA</p>
          </div>
        </div>
        <div className="max-w-screen-2xl w-full place-self-center text-left pt-10 pb-10">
          <p className="text-textsecondary pt-4">
            © {new Date().getFullYear()} DME-Tech LLC. All rights reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
